import React from 'react';
import { signInWithGoogle } from '../firebase';
import { Box, Button, Container } from '@mui/material';
import GoogleIcon from '@mui/icons-material/Google';
import '../styles/Login.scss';
import lifeAppLogo from '../logo.png';

function Login({ onLoginSuccess }) {
  const handleGoogleSignIn = async () => {
    try {
      const user = await signInWithGoogle();
      console.log('User signed in:', user);
      onLoginSuccess(user);
    } catch (error) {
      console.error('Sign in failed:', error);
      alert('Failed to sign in. Please try again.');
    }
  };

  return (
    <Container maxWidth="sm" className="login-screen">
      <Box
        sx={{
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
          justifyContent: 'center',
          minHeight: '100vh',
          gap: 3,
        }}
      >
        <img src={lifeAppLogo} alt="Life App Logo" className="login-logo" />
        <h1 className="lexend">Life App</h1>
        <p className="lexend" align="center" gutterBottom>
          Track your daily activities and progress
        </p>
        <Button
          variant="contained"
          size="large"
          startIcon={<GoogleIcon />}
          onClick={handleGoogleSignIn}
          className="lexend"
          sx={{
            backgroundColor: '#4285F4',
            color: 'white',
            padding: '12px 32px',
            fontSize: '16px',
            '&:hover': {
              backgroundColor: '#357ae8',
            },
          }}
        >
          Sign in with Google
        </Button>
      </Box>
    </Container>
  );
}

export default Login;
